import { StadiaLatLng, StadiaMapsReverseGeocodingResult } from './stadia-maps.types';
import { AddressDetails } from '@pedix-workspace/utils';

export function getStadiaMapsAddressDetails(
  place: StadiaMapsReverseGeocodingResult,
  freeSearch?: string | null,
  geolocation?: StadiaLatLng,
): AddressDetails {
  const useCustomLocation = Boolean(geolocation);

  const street = place.properties.street || '';
  const streetNumber = place.properties.housenumber || '';

  const state = place.properties.region;
  const locality = place.properties.locality;
  const country = place.properties.country;
  const postalCode = place.properties.postalcode;
  const neighborhood = place.properties.neighbourhood;

  // NOTE: in some scenarios geolocation comes as a Point instance, so we better access its single property and create a raw object so Firebase won't complain
  const [lng, lat] = place.geometry.coordinates;
  const coordinates = {
    lat,
    lng,
  };

  const fullAddressComponents = [];

  if (useCustomLocation && freeSearch) {
    fullAddressComponents.push(freeSearch);
  } else if (street) {
    fullAddressComponents.push(streetNumber ? `${street} ${streetNumber}` : street);
  } else if (freeSearch) {
    fullAddressComponents.push(freeSearch);
  }
  if (locality) {
    fullAddressComponents.push(locality);
  }
  if (state) {
    fullAddressComponents.push(state);
  }
  if (country) {
    fullAddressComponents.push(country);
  }

  const fullAddress = fullAddressComponents.join(', ');
  const url = `https://maps.google.com/?q=${coordinates.lat},${coordinates.lng}`;

  return {
    freeSearch: freeSearch || undefined,
    fullAddress,
    url,
    street,
    streetNumber,
    state,
    locality,
    country,
    postalCode,
    neighborhood,
    coordinates,
    useCustomLocation,
  };
}
